import logger from 'redux-logger'
import { configureStore } from '@reduxjs/toolkit'

import reducers from '../reducers';

const preloadedState = {
    common: {}
};

const isDebug = process.env.NODE_ENV !== 'production';
console.log('isDebug: ' + isDebug);

export default (history, saga) => configureStore({
    reducer: reducers(history),
    middleware: isDebug ? [saga, logger] : [saga],
    devTools: isDebug,
    preloadedState
});